import React from 'react';

import Paragraph from '@/components/Elements/Paragraph/Paragraph';

import { PortfolioParagraphContentProps } from '@/helpers/getParagraphForDynamicPage';

import { IDescription } from '@/types/types';

import './TextParagraph.scss';

interface TextProps extends PortfolioParagraphContentProps {
  description: IDescription;
}

export const TextParagraph = ({ id, description }: TextProps) => (
  <div className="TextParagraph_wrapper">
    <Paragraph key={id} item={description.data.description} />
  </div>
);
